import {HPPData, HPPDataError, OrderHistoryBucket, PaymentOrderHistory} from './types';

export const isHPPDataError = (data: HPPData | HPPDataError): data is HPPDataError => {
  return !!(data as HPPDataError)?.error;
};

export const toOrderHistoryGroups = (
  bucket?: OrderHistoryBucket,
): PaymentOrderHistory[] => (bucket ? [bucket].flat() : []);
